import { baseRoutes } from "helpers/baseRoutes";

const accessRoute = {
  MANAGE_COUPEN: {
    path: `${baseRoutes.adminBaseRoutes}/manage-coupon`,
    icon: (
      <span className="nk-menu-icon">
        <em className="icon-coupon" />
      </span>
    ),
  },
  USED_COUPON: {
    path: `${baseRoutes.adminBaseRoutes}/coupon-details`,
  },
};

export default accessRoute;
